import { render, staticRenderFns } from "./WidthNormalIcon.vue?vue&type=template&id=12507030"
import script from "./WidthNormalIcon.vue?vue&type=script&lang=js"
export * from "./WidthNormalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports